var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._g(
      {
        staticClass: "_field",
        class: _vm._class,
        style: { width: _vm.width, height: _vm.height }
      },
      _vm.__fwd
    ),
    [
      _vm.$slots.start
        ? _c("div", { staticClass: "_flds" }, [_vm._t("start")], 2)
        : _vm._e(),
      _c(
        "span",
        { staticClass: "_fldi" },
        [
          _vm._v(_vm._s(_vm._prefix)),
          _vm.privacy || _vm._placeholder
            ? _c("label", {
                staticClass: "_fldl",
                class: { _dock: !_vm.security && !_vm.empty },
                attrs: { for: _vm._id },
                domProps: {
                  textContent: _vm._s(_vm.security || _vm._placeholder)
                }
              })
            : _vm._e(),
          _c(
            _vm.multiline ? "textarea" : "input",
            _vm._g(
              _vm._b(
                {
                  ref: "_in",
                  tag: "component",
                  staticClass: "_fldin",
                  class: _vm._iclass,
                  attrs: {
                    id: _vm._id,
                    name: _vm.name,
                    required: _vm.required,
                    readonly: _vm.readonly,
                    disabled: _vm.disabled,
                    inert: _vm.inert,
                    autofocus: _vm.autofocus,
                    tabindex: _vm.inert ? -1 : _vm.tabindex
                  },
                  on: {
                    change: _vm.change,
                    drop: _vm.drop,
                    paste: _vm.paste,
                    keydown: [
                      _vm.keydown,
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onEnter($event)
                      }
                    ],
                    keypress: _vm.keypress,
                    input: _vm.input,
                    select: _vm._select
                  }
                },
                "component",
                _vm.bind,
                false
              ),
              _vm.__on
            )
          ),
          _vm._v(_vm._s(_vm._suffix))
        ],
        1
      ),
      _vm.$slots.default || _vm.$slots.end
        ? _c(
            "div",
            { staticClass: "_flde" },
            [_vm._t("default"), _vm._t("end")],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }